import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import LeadAssessmentModal from 'LeadAssessmentModal';
import IfiLrrpModal from '../phaseActionMenu/ifiLrrpModal.jsx';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import { updatePhaseTask, overridePhaseStatus } from 'actionCreators/phase';
import PhaseTask from './phase_task';
import isIfiPhase from '../ifiUtils';

export class LeadAssessment extends PhaseTask {
  isDisabled = () => false

  onClick = () => {
    if (this.props.task.status === 'complete') this.toggleStatus();
    else this.setState({ modalActive: true });
  }

  renderChildren = () => {
    const { phase } = this.props;
    if (phase.type === 'Workorder' && isIfiPhase(phase)) {
      return (<IfiLrrpModal
        phase={phase}
        taskSlug="lead_assessment"
        active={this.state.modalActive}
        onClose={this.handleClose}
      />);
    }

    return (<LeadAssessmentModal
      phase={this.props.phase}
      task={this.props.task}
      active={this.state.modalActive}
      updatePhaseTask={this.props.updatePhaseTask}
      overridePhaseStatus={this.props.overridePhaseStatus}
      onClose={this.handleClose}
    />);
  }
}

LeadAssessment.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
};

const lead_assessment = connect(
  () => ({}), { updatePhaseTask, overridePhaseStatus },
)(LeadAssessment);

export { lead_assessment };



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/lead_assessment.jsx